<template>
	<div
		class="
			fixed top-[140px] right-10 flex w-[160px] flex-col items-center
			gap-2 rounded-[8px] bg-white p-[11px]"
	>
		<h3 class="text-center text-[14px] tracking-[0.56px] text-[#686e77] uppercase">
			Resume score
		</h3>

		<ScoreCircle
			:progress="score?.totalScore"
			:max-total="maxTotal"
			:pending="noScoreYet"
		/>
        
		<button
			class="mx-auto w-fit font-medium text-won-green"
			@click="openResumeScorerHandler"
		>
			Show More
		</button>
	</div>
</template>

<script setup>
import { watch } from 'vue';
import { storeToRefs } from 'pinia';

import { useBuilder } from '../../store/builder.store';
import { useResumeScorerStore } from '../../store/scorer.store';

import ScoreCircle from './score-circle.vue';
import { useSidebarStore } from '../../store/sidebar.store';

const builder = useBuilder();
const scorerStore = useResumeScorerStore();
const sidebarStore = useSidebarStore();

const { collapsed: isSidebarCollapsed } = storeToRefs(sidebarStore);

const { getScore: score, maxTotal, noScoreYet } = storeToRefs(scorerStore);

const { loaded, data, saveCount } = storeToRefs(builder);

defineProps({
	showPanel: {
		type: Function,
		default: () => {}
	}
});

// EN-916: the panel itself now opens for everyone — free-tier users see a
// per-category "0 recommendations" upsell inside it instead of being kept
// out entirely (2026-08-26 standup decision).
const openResumeScorerHandler = () => {
	scorerStore.setShowResumeScorer();

	if (!isSidebarCollapsed.value) {
		sidebarStore.sidebarCollapseHandler();
	}
};

// The score endpoint's own cache is keyed on the resume's last save, so
// there's nothing to gain from fetching more often than the resume actually
// gets (re)loaded or saved (EN-797). Immediate because the builder layout
// unmounts this card while the bullet generator is open, and every save
// counts, not just ones outside the 2s "Saved" badge (EN-1003).
watch(() => data.value?.uuid, (uuid) => {
	if (!loaded.value || uuid == null) {return;}

	scorerStore.fetchScore();
}, { immediate: true });

watch(saveCount, () => {
	scorerStore.fetchScore();
});
</script>
